import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchFormData, fetchData } from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";
import { BaseUrl } from "../..";
const SubjectCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [courseOptions, setCourseOptions] = useState([]);
  const [semesterOptions, setSemesterOptions] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    course_id: "",
    semester_id: "",
    image: "",
    newImage: "",
    description: "",
    status: "1",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Redirect if not logged in
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, []);

  // Handle input change
  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // Load course dropdown
  const fetchCourses = async () => {
    try {
      const result = await fetchData("course-dropdown", {}, "POST");

      if (result?.success && Array.isArray(result.data)) {
        const options = result.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));

        setCourseOptions(options);
      }
    } catch (error) {
      console.error("Failed to load courses:", error);
    }
  };

  // Load semesters based on course_id
  const fetchSemesters = async (course_id) => {
    if (!course_id) return;

    const form = new FormData();
    form.append("course_id", course_id);

    try {
      const result = await fetchFormData("semester-dropdown", form, "POST");

      if (result?.success && Array.isArray(result.data)) {
        const options = result.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        setSemesterOptions(options);
      }
    } catch (error) {
      console.error("Failed to load semesters:", error);
    }
  };

  // Load selected subject for editing
  const fetchAllDetails = async (id) => {
    const form = new FormData();
    form.append("id", id);

    try {
      const result = await fetchFormData("subject-details", form, "POST");
      // console.log(result)
      // if (result?.success && result?.data)
      const d = result.data;
      if (d) {
        setFormData({
          id: d.id,
          title: d.title || "",
          course_id: d.course_id || "",
          semester_id: d.semester_id || "",
          image: d.image || "", //url from backend
          newImage: "", //reset new mage
          description: d.description || "",
          status: d.status?.toString() || "1",
        });

        // Load semesters for selected course
        fetchSemesters(d.course_id);
      } else {
        topTost({ title: "Subject not found", icon: "warning" });
      }
    } catch (error) {
      console.log("Fetch error:", error);
      topTost({ title: "Server error", icon: "error" });
    }
  };

  useEffect(() => {
    fetchCourses();

    if (id) {
      fetchAllDetails(id);
    }
  }, [id]);

  const fileToBase64 = (file) => {
    return new Promise((resolve) => {
      if (!file) return resolve("");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = new FormData();

    form.append("id", id);

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "newImage") {
        if (value) form.append("image", value);
      } //only upload new image
      else if (key !== "image") {
        form.append(key, value ?? "");
      }
    });

 

  try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        id ? `${BaseUrl}update-subject` : `${BaseUrl}create-subject`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        }
      );
  
      const data = await response.json();
      const result = data.result;
      if (!result) return;
  
      // Handle validation errors
        if (result?.success==="false" && result?.errors) {
        const firstField = Object.keys(result.errors)[0];
        const errorMsg = result.errors[firstField][0];
        topTost({ title: errorMsg, icon: "error" });
        setIsSubmitting(false);
        return;
      }
      
      // Handle success
      if (
        result?.success === "true" ||
        result?.success === true ||
        result?.code === 200 ||
        result?.code === "200"
      ) {
        topTost({
          title: result.message || (id ? "Updated successfully!" : "Saved successfully!"),
          icon: "success",
        });
        setTimeout(() => {
               navigate("/master/subject-list");
        }, 600);
   
        setIsSubmitting(false);
        return;
      }
  
      // Handle other errors
      topTost({
        title: result?.message || "Error submitting form",
        icon: "error",
      });
    } catch (error) {
      topTost({ title: "Error submitting form", icon: "error" });
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                {id ? "Edit Subject:" : "Add Subject:"}
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="p-3 ">
              {/* Course Dropdown */}
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="course-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Course: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="course-select"
                    name="course_id"
                    value={formData.course_id}
                    onSelectOption={(option) => {
                      handleChange("course_id", option.value);
                      fetchSemesters(option.value); // Load semesters after course select
                    }}
                    options={courseOptions}
                    placeholder="Select Course"
                    icon="fa-opera"
                    required
                  />
                </div>
              </div>

              {/* Semester Dropdown */}
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="semester-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Semester: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="semester-select"
                    name="semester_id"
                    value={formData.semester_id}
                    onSelectOption={(option) =>
                      handleChange("semester_id", option.value)
                    }
                    options={semesterOptions}
                    placeholder="Select Semester"
                    icon="feather-archive"
                    required
                  />
                </div>
              </div>

              {/* Title */}
              <Input
                label="Subject Title"
                name="title"
                placeholder="Enter Subject Title"
                value={formData.title}
                onChange={handleChange}
                icon="feather-hash"
                required
              />
              {/* for existing imge */}
              {formData.image && !formData.newImage && (
                <div className="mb-3 row align-items-center">
                        <label   className="col-lg-2 col-md-2 col-sm-4 fw-semibold">Current Image:</label>
                        <div className="col-lg-6 col-md-6 col-sm-8 ">
                  <img
                    src={formData.image}
                   className="img-fluid rounded"
                    alt="Subject"
                    style={{
                    maxHeight:"100px",
                      objectFit: "cover",
                    }}
                  /></div>
                </div>
              )}

              <Input
                label="Image"
                name="image"
                type="file"
                accept="image/*"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  const base64 = await fileToBase64(file);
                  setFormData((prev) => ({
                    ...prev,

                    newImage: base64,
                  }));
                }}
                icon="feather-compass"
              />

              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubjectCreate;
